import get from 'lodash/get';
import { ADDITIONAL_EMAIL_EVENTS, EVENT_TYPES_LOOKUP } from './constants';
import type { WebhookParamProps } from './types';

/**
 * Consolidates the enabled events of a webhook with additional email events if applicable.
 * @returns { Array } List of enabled events
 */
export const getEnabledEvents = (rowData: Record<string, any>) => {
  const enabledEvents = [...get(rowData, 'enabledEvents', [])];
  ADDITIONAL_EMAIL_EVENTS.map((event) => rowData[event] && enabledEvents.push(event));
  return enabledEvents;
};

/**
 * Returns the trigger event type for a given enabled event name.
 * Returns null if a matching event cannot be found in `EVENT_TYPES_LOOKUP`.
 */
export const getEventType = (eventName: string): string | null =>
  Object.entries(EVENT_TYPES_LOOKUP).find(([, { events }]) =>
    Object.keys(events).includes(eventName),
  )?.[0] || null;

/**
 * tableFilterFn
 * filters webhook table based on a webhook's id or endpoint
 */
export const tableFilterFn = (webhook: WebhookParamProps, filter: string) => {
  if (webhook.id.toString().includes(filter)) return true;
  if (webhook.endpoint.includes(filter)) return true;

  return false;
};
